<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="gallery-stack" :class="{'min-height': isEditMode}">
      <div
        class="gallery-stack__image"
        v-for="image in imagesSources"
        :key="image.id"
        :class="{'full-width': image.value.fullWidth}"
      >
        <sc-image v-if="isEditMode" :media="image.value.media || {}" class="img"/>
        <picture v-else>
          <source media="(max-width: 420px)" :srcset="image.value.mobileSrc">
          <img  class="img" :src="image.value.src" :alt="image.value.alt"/>
        </picture>
      </div>
    </div>
  </sc-render>
</template>

<script>

import { Image } from '@sitecore-jss/sitecore-jss-vue'
import { ShImage } from '@sohohouse/design-system'
import { createNamespacedHelpers } from 'vuex'
import get from '~/helpers/get'
import mapFields from '~/helpers/map-fields'
import { arrayUID } from '~/helpers/unique-id'
import ScRender from '../sc-render'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'GalleryStack',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScImage: Image,
    ScRender,
    ShImage
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapFields({
      images: 'images',
      image0: 'images.0.fields.image',
      image1: 'images.1.fields.image',
      image2: 'images.2.fields.image'
    }),
    hasImages () {
      return this.image0 && this.image1
    },
    imagesSources () {
      const sources = this.imageMapping.map(key => ({
        media: key.field,
        alt: get(key.field, 'value.alt'),
        src: get(key.field, ['value', key.ratio]),
        fullWidth: key.fullWidth,
        mobileSrc: get(key.field, 'value.cloudinary_3x4_fill_crop')
      }))

      return arrayUID(sources)
    },
    imageMapping () {
      if (!this.hasImages) {
        return []
      }

      if (this.images.length === 3) {
        return [
          { field: this.image0, ratio: 'cloudinary_5x3_fill_crop', fullWidth: true },
          { field: this.image1, ratio: 'cloudinary_3x4_fill_crop' },
          { field: this.image2, ratio: 'cloudinary_3x4_fill_crop' }
        ]
      }

      return [
        { field: this.image0, ratio: 'cloudinary_3x4_fill_crop' },
        { field: this.image1, ratio: 'cloudinary_3x4_fill_crop' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

.gallery-stack {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: $space-110;

  &.min-height {
    min-height: 200px;
  }

  .gallery-stack__image {
    width: 100%;

    .img {
      display: block;
      width: 100%;
    }

    &.full-width {
      width: 100%;
    }

    ::v-deep .sc-image-wrapper img {
      width: 100%;
    }

    @include breakpoint(small) {
      width: 50%;
    }
  }
}
</style>
